import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSessionStorage } from 'shared';

import { REFERRAL_QUERY_KEY, TAP2MINE_REFERRAL_SS_KEY } from '../../constants/key';

export const useSaveRefCode = () => {
  const [searchParams] = useSearchParams({ ref: '' });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, saveCode] = useSessionStorage(TAP2MINE_REFERRAL_SS_KEY, '');

  const rawRef = searchParams.get(REFERRAL_QUERY_KEY);
  const cleanedRef = rawRef?.split('?')[0]; // '08eGsU9W'

  useEffect(() => {
    if (cleanedRef) saveCode(cleanedRef);
  }, [cleanedRef]);
};
